import * as React from 'react';
import { SVGProps } from 'react';

const SvgBloodBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="var(--icon-fill-secondary)"
      d="M12.483 14.404h14.776v10.308a2.644 2.644 0 0 1-2.644 2.644h-9.488a2.644 2.644 0 0 1-2.644-2.645V14.405Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M25.302 30.837h-10.83a5.596 5.596 0 0 1-5.597-5.597V8.846a5.596 5.596 0 0 1 5.596-5.596h10.83a5.596 5.596 0 0 1 5.597 5.596V25.24a5.596 5.596 0 0 1-5.596 5.597Z"
    />
    <path
      fill={props.fill}
      d="M22.404 36.875v-7.933h-5.288v2.692l5.288 5.241Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20 7.75h7m-18 4h5.5M9 17h5.5M9 22h5.5m4-10.25H27"
    />
  </svg>
);

export default SvgBloodBag;
